import { Type } from "@sinclair/typebox";
import { JsonValueSchema } from "./shared.js";
import { InputTreePlanSchema, InputTreeMaterializedSchema } from "./files.js";
import { FunctionContractSchema, RuntimeExecutionLeaseSchema, RuntimeExecutionAdmissionSchema, } from "./tools.js";
export const BioscienceArtifactSchema = Type.Object({
    uri: Type.String({ pattern: "^bioscience://files/file_[a-f0-9]{32}$" }),
    filename: Type.String({ minLength: 1, maxLength: 255 }),
    sha256: Type.String({ pattern: "^[a-f0-9]{64}$" }),
    size_bytes: Type.Integer({ minimum: 0, maximum: Number.MAX_SAFE_INTEGER }),
    media_type: Type.String({ minLength: 1, maxLength: 255 }),
    format: Type.String({ minLength: 1, maxLength: 64 }),
}, { additionalProperties: false });
/** 平台合同与本地辅助 IPC；远端 MCP 自身使用官方 SDK 的标准线协议。 */
export const ToolsMessageBodySchema = Type.Union([
    Type.Object({ kind: Type.Literal("function_contract"), value: FunctionContractSchema }, { additionalProperties: false }),
    Type.Object({ kind: Type.Literal("bioscience_artifact"), value: BioscienceArtifactSchema }, { additionalProperties: false }),
    Type.Object({ kind: Type.Literal("content"), value: JsonValueSchema }, { additionalProperties: false }),
    Type.Object({ kind: Type.Literal("input_tree_plan"), value: InputTreePlanSchema }, { additionalProperties: false }),
    Type.Object({ kind: Type.Literal("input_tree_materialized"), value: InputTreeMaterializedSchema }, { additionalProperties: false }),
    Type.Object({ kind: Type.Literal("runtime_execution_lease"), value: RuntimeExecutionLeaseSchema }, { additionalProperties: false }),
    Type.Object({ kind: Type.Literal("runtime_execution_admission"), value: RuntimeExecutionAdmissionSchema }, { additionalProperties: false }),
]);
//# sourceMappingURL=mcp.js.map